import {inject, Injectable} from '@angular/core';
import {ConfirmService} from "../../../../../../core/services/confirm.service";
import {DeleteConfirmationParams} from "../../../../../../core/types/confirmation-modal.types";
import {defaultDeleteConfirmationParams} from "../../../../../../core/models/default-delete-confirmation-params";

@Injectable({
  providedIn: 'root'
})
export class ProductPackagesFormFieldService {
  private confirmService: ConfirmService = inject(ConfirmService);

  public async isDeleteConfirmed(recordId: string | number): Promise<boolean> {
    const deleteConfirmationParams: DeleteConfirmationParams = {
      ...defaultDeleteConfirmationParams,
      description: `Вы уверены, что хотите удалить запись №${recordId}?`
    };

    return await this.confirmService.getDeleteConfirmation(deleteConfirmationParams);
  }
}
